var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtnUp = function SvgBtnUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a123"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fa3300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fa3300",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#a123)",
    cx: 22.5,
    cy: 22.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fa3300",
    d: "m13.308 25.5 9.203-9.041 4.444 4.376 4.737 4.665"
  }))));
};
export default SvgBtnUp;